<template>
  <div class="how-to">
    <h1 class="text-shadow-thin-white">{{ $t("mainz.howToPlay") }}</h1>
    <p>{{ $t("mainz.howP1") }}</p>
    <p>
      <span class="highlight text-shadow-extra-thin-white">
        {{ $t("mainz.howP2Highlight") }}
      </span>
      {{ $t("mainz.howP2") }}
    </p>
  </div>
</template>
<script>
export default {
  name: "MainzHowTo",
};
</script>
